import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  ControlContainer,
  FormGroupDirective,
} from '@angular/forms';
import { CheckboxField } from '../../../core/models/checkbox-field';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class ToggleComponent implements OnInit {
  /**
   * * General
   * @errors Form control errors
   * @specificFormGroup Set custom form group
   */
  errors: any = {};
  specificFormGroup: FormGroup;
  /**
   * * Inputs
   * @options Configuration for this form field
   * @customFormGroup Used when you want to use this component without form-builder
   */
  @Input() options: CheckboxField;
  @Input() customFormGroup: any;
  @Input() customFormGroupName: any;

  onOffLabel: string;

  constructor(public controlContainer: ControlContainer) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    const formGroup = this.controlContainer.control as FormGroup;

    formGroup
      .get(this.options.formControlName)
      .valueChanges.subscribe((res) => {
        if (res) {
          this.onOffLabel = 'ON';
        } else {
          this.onOffLabel = 'OFF';
        }
      });

    if (this.options.fieldFormGroup || this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.getSpecificFormGroup(
        this.options.fieldFormGroup
      );
    } else {
      this.specificFormGroup = this.customFormGroup;
    }
    if (this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.customFormGroup;
    }

    // this.specificFormGroup = this.options.fieldFormGroup !== '' ? this.getSpecificFormGroup(this.options.fieldFormGroup) : this.customFormGroup;
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  onChange(event) {
    const formGroup = this.controlContainer.control as FormGroup;

    if (event.checked) {
      this.onOffLabel = 'ON';
    } else {
      this.onOffLabel = 'OFF';
    }

    if (this.customFormGroup && this.options.fieldFormGroup !== undefined) {
      this.errors =
        this.customFormGroup.controls[this.options.formControlName].errors;
    } else if (
      this.customFormGroup &&
      (this.options.fieldFormGroup || this.options.fieldFormGroup == '')
    ) {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    } else {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    }
  }

  getSpecificFormGroup(formGroupPath: string) {
    return <FormGroup>this.customFormGroup.get(formGroupPath);
  }
}
